import {ApiClient} from '@hconnect/apiclient'
import {useMutation, useQueryClient} from '@tanstack/react-query'

export type ResponseType = {
  data: string
}

export const useFinishAnalysis = (analysisId: string | undefined) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async () => {
      const path = `/rootcausefailureanalysis/analyses/${analysisId}/statuses`
      return (
        await ApiClient.axiosInstance.post<ResponseType>(path, {
          status: 'Finished',
          privacyStatus: 'Public'
        })
      ).data
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({queryKey: ['analysis-detail']})
      await queryClient.invalidateQueries({queryKey: ['analysis-summary']})
      await queryClient.invalidateQueries({queryKey: ['analysis-list']})
      queryClient.removeQueries({queryKey: ['analysis-pdfsummary']})
      return {data: true}
    }
  })
}
